export default __webpack_public_path__ + "static/media/property_401.f07fce6d.png";